export const GET_APPLICATION_LIST = 'app/endUserModule/lateral-menu/GET_APPLICATION_LIST';
export const GET_APPLICATION_LIST_RETURN = 'app/endUserModule/lateral-menu/GET_APPLICATION_LIST_RETURN';
export const GET_FORM_FIELD = 'app/endUserModule/lateral-menu/GET_FORM_FIELD';
export const GET_FORM_FIELD_RETURN = 'app/endUserModule/lateral-menu/GET_FORM_FIELD_RETURN';